import { SESSION_STORAGE_KEYS } from '@/constants/session-storage'

const { UCS_TOAST_MESSAGES, PAGE_ALERTS } = SESSION_STORAGE_KEYS

type PageAlertStorageItem = {
  type: string
  contentId: string
  vars?: Record<string, unknown>
}

export const setStorageItem = ({ key, value, sessionBased = true }) => {
  if (sessionBased) {
    window.sessionStorage.setItem(key, value)
    return
  }

  window.localStorage.setItem(key, value)
}

export const getStorageItem = ({ key, sessionBased = true }) => {
  if (sessionBased) {
    return window.sessionStorage.getItem(key)
  }

  return window.localStorage.getItem(key)
}

export const removeStorageItem = ({ key, sessionBased = true }) => {
  if (sessionBased) {
    window.sessionStorage.removeItem(key)
    return
  }

  window.localStorage.removeItem(key)
}

export const getToastMessagesFromSessionStorage = () =>
  JSON.parse(getStorageItem({ key: UCS_TOAST_MESSAGES })) || {}

export const setToastMessageInSessionStorage = (eventId, formattedMessage) => {
  const toastMessages = getToastMessagesFromSessionStorage()
  toastMessages[eventId] = formattedMessage
  setStorageItem({ key: UCS_TOAST_MESSAGES, value: JSON.stringify(toastMessages) })
}

export const removeToastMessagesFromSessionStorage = () => {
  removeStorageItem({ key: UCS_TOAST_MESSAGES })
}

type PageAlertInput =
  | PageAlertStorageItem
  | {
      type?: string
      contentId: string
      estimatedDays?: number
    }

function normalizePageAlerts(input: PageAlertInput | PageAlertInput[]): PageAlertStorageItem[] {
  const isLegacySingleObject = !Array.isArray(input)
  const items = Array.isArray(input) ? input : [input]

  return items.map((alert) => {
    if ('vars' in alert && alert.vars !== undefined) {
      return {
        type: alert.type ?? 'success',
        contentId: alert.contentId,
        vars: alert.vars,
      }
    }

    if (!isLegacySingleObject) {
      return {
        type: alert.type ?? 'success',
        contentId: alert.contentId,
      }
    }

    const {
      type = 'success',
      contentId,
      estimatedDays = 10,
    } = alert as {
      type?: string
      contentId: string
      estimatedDays?: number
    }

    return {
      type,
      contentId,
      vars: { estimatedDays },
    }
  })
}

export const setPageAlertsInSessionStorage = (input: PageAlertInput | PageAlertInput[]) => {
  const alerts = JSON.stringify(normalizePageAlerts(input))
  setStorageItem({
    key: PAGE_ALERTS,
    value: alerts,
  })
}
